import {Icon, IconProps} from '@chakra-ui/react';

export function ArrowToIcon(props: IconProps) {
  return (
    <Icon width="11px" height="13px" viewBox="0 0 11 13" fill="none" {...props}>
      <path
        d="M6.66664 2.99275C6.45181 2.77197 6.10366 2.77208 5.88883 2.99286L5.11113 3.79197C4.8963 4.01275 4.8963 4.37065 5.11124 4.59142L7.24413 6.78268H3.29999C2.69246 6.78268 2.19999 6.27647 2.19999 5.65224V0.565224C2.19999 0.252994 1.9537 0 1.64999 0H0.549998C0.246289 0 0 0.252994 0 0.565224V5.65224C0 7.52527 1.4774 9.04358 3.29999 9.04358H7.24479L5.11212 11.236C4.8974 11.4567 4.8974 11.8145 5.11223 12.0353L5.88993 12.8344C6.10476 13.0552 6.45302 13.0552 6.66784 12.8344L10.678 8.71224C11.1074 8.2708 11.1073 7.55523 10.6778 7.1139L6.66664 2.99275Z"
        fill="currentColor"
      />
    </Icon>
  );
}
